// export const CommonConfig = {
//     dev: {
//         baseUrl: 'https://obsandbox.maveric-systems.com',
//         baseUrl1: 'https://obsandbox.maveric-systems.com',
//         baseUrl2: '',
//         baseUrl6050: 'https://obsandbox.maveric-systems.com/api/util',
//         baseUrl7030: '',
//         baseUrl5080: 'https://obsandbox.maveric-systems.com',
//     },
// };

let CommonConfig = 'https://obsandbox.maveric-systems.com';

if (process.env.REACT_APP_ENV === 'development') {
    CommonConfig = {
        dev: {
            baseUrl: 'https://obsandbox.maveric-systems.com',
            baseUrl1: 'https://obsandbox.maveric-systems.com',
            baseUrl2: '',
            baseUrl6050: 'https://obsandbox.maveric-systems.com/api/util',
            baseUrl7030: '',
            baseUrl5080: 'https://obsandbox.maveric-systems.com',
            // appUrl: 'https://api.itecapp.in',
            appUrl: 'https://advithapi.mindstack.in',
        },
    };
}

if (process.env.REACT_APP_ENV === 'staging') {
    CommonConfig = {
        dev: {
            baseUrl: 'https://api.advithitec.in',
            // baseUrl: 'http://localhost:5020',
            // baseUrl: 'http://advithadmin.mindstack.in',
            baseUrl1: 'https://api.advithitec.in',
            baseUrl2: '',
            baseUrl6050: 'https://api.advithitec.in/api/util',
            baseUrl7030: '',
            baseUrl5080: 'https://api.advithitec.in',
            // appUrl: 'https://advithapi.mindstack.in',
            appUrl: 'https://api.itecapp.in',
        },
    };
}

if (process.env.REACT_APP_ENV === 'preprod') {
    CommonConfig = {
        dev: {
            baseUrl: 'https://api.itecapp.in',
            baseUrl1: 'https://api.itecapp.in',
            baseUrl2: '',
            baseUrl6050: 'https://api.itecapp.in/api/util',
            baseUrl7030: '',
            baseUrl5080: 'https://api.itecapp.in',
            appUrl: 'https://api.itecapp.in/',
        },
    };
}

if (process.env.REACT_APP_ENV === 'production') {
    CommonConfig = {
        dev: {
            baseUrl: 'https://api.advithitec.in/',
            baseUrl1: 'https://api.advithitec.in/',
            baseUrl2: '',
            baseUrl6050: 'https://api.advithitec.in//api/util',
            baseUrl7030: '',
            baseUrl5080: 'https://api.advithitec.in/',
            appUrl: 'https://api.itecapp.in/',
        },
    };
}

export { CommonConfig };

// below code need to add in package.json file

// "dev": "REACT_APP_ENV=development npm start",
// "prod": "REACT_APP_ENV=production npm start",
